module.exports = __webpack_public_path__ + "Roboto-msdf.json";


//////////////////
// WEBPACK FOOTER
// ./src/Roboto-msdf.json
// module id = 6
// module chunks = 0